



























































































































































































































































































































































































































































import ALPage from '@/components/core/Page/ALPage.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import FormBuilderSectionToolbar from '@/components/form-builder/FormBuilderSectionToolbar.vue';

import DeleteConfirmationDialog from '@/components/common/DeleteConfirmationDialog.vue';
import Messages from '@/components/common/Messages.vue';
import WorkflowFormBuilderPropertiesDrawer from '@/components/workflow-form-builder/WorkflowFormBuilderPropertiesDrawer.vue';
import WorkflowFormBuilderTemplateDetailCard from '@/components/workflow-form-builder/WorkflowFormBuilderTemplateDetailCard.vue';
import WorkflowFormBuilderSectionFieldsDrawer from '@/components/workflow-form-builder/WorkflowFormBuilderSectionFieldsDrawer.vue';
import WorkflowFormBuilderDetailStateCard from '@/components/workflow-form-builder/WorkflowFormBuilderDetailStateCard.vue';
import WorkflowFormTemplateWizardFormDialog from '@/components/workflow-form-builder/WorkflowFormTemplateWizardFormDialog.vue';
import WorkflowFormTemplateAddAttachmentsFormDialog from '@/components/workflow-form-builder/WorkflowFormTemplateAddAttachmentsFormDialog.vue';
import WorkflowFormBuilderMetaLabelColumnsDialog from '@/components/workflow-form-builder/WorkflowFormBuilderMetaLabelColumnsDialog.vue';
import WorkflowFormBuilderRevisionGrantAccessCardDialog from '@/components/workflow-form-builder/WorkflowFormBuilderRevisionGrantAccessCardDialog.vue';

import {
  WorkflowFormSection,
  IWorkflowFormFieldData,
  IWorkflowFormSectionData,
  IWorkflowFormTemplateRevision,
  IAttachment,
  WorkflowFormTemplateStateEnum,
  IWorkflowFormTemplateRevisionStatus
} from '@/models';
import { ErrorManager, ISystemError } from '@/models/error';

import { deepEqual, diffDeep, setErrorFromAxiosError } from '@/utils/helpers';

import auth from '@/mixins/auth';
import draggable from '@/mixins/draggable';
import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';

import { cloneDeep } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { AxiosError } from 'axios';
import { requiredValidator } from '@/utils/validators';
import { ALForm } from '@/common/component.types';

const baseMixins = mixins(auth, snackbar, draggable);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
    workflowFormTemplateRevisionDialog: InstanceType<
      typeof WorkflowFormTemplateWizardFormDialog
    >;
    addAttachmentsFormDialog: InstanceType<
      typeof WorkflowFormTemplateAddAttachmentsFormDialog
    >;
    workflowFormBuilderMetaLabelColumnsDialog: InstanceType<
      typeof WorkflowFormBuilderMetaLabelColumnsDialog
    >;
    workflowFormBuilderRevisionGrantAccessCardDialog: InstanceType<
      typeof WorkflowFormBuilderRevisionGrantAccessCardDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'FormBuilderDetailPage',
    components: {
      ALPage,
      ConfirmationDialog,
      DeleteConfirmationDialog,
      ErrorAlert,
      FormBuilderSectionToolbar,
      Messages,
      WorkflowFormBuilderTemplateDetailCard,
      WorkflowFormBuilderPropertiesDrawer,
      WorkflowFormBuilderSectionFieldsDrawer,
      WorkflowFormBuilderDetailStateCard,
      WorkflowFormTemplateAddAttachmentsFormDialog,
      WorkflowFormBuilderMetaLabelColumnsDialog,
      WorkflowFormTemplateWizardFormDialog,
      WorkflowFormBuilderRevisionGrantAccessCardDialog
    },

    provide(): { formBuilder: any } {
      //form builder component
      return {
        formBuilder: this
      };
    },

    data() {
      return {
        revisionLoading: false,
        loading: false,
        showErrorSnackbar: false,
        deleteDialog: false,

        errorMessage: '',
        detailErrorMessage: '',

        revision: null as null | IWorkflowFormTemplateRevision,

        tab: 0 as number,
        sectionIndex: -1,

        navDrawer: false,
        fieldDrawer: false,

        selectedSectionIndex: 0,
        selectedFieldIndex: -1,

        parentFieldId: null as null | number,

        attachmentDeleteDialog: false,
        isAttachmentDeleteInProgress: false,
        attachmentDeleteError: null as ISystemError | null,
        selectedAttachment: null as null | IAttachment,

        createNewRevisionDialog: false,

        createNewRevisionError: null as ISystemError | null,
        createNewRevisionInProgress: false,

        WorkflowFormTemplateStateEnum,

        grantAccessDialog: false
      };
    },

    computed: {
      ...mapGetters({
        getWorkflowFormTemplateRevisionById:
          'workflowFormTemplate/getWorkflowFormTemplateRevisionById',
        getLastCreatedWorkflowFormTemplateRevisionId:
          'workflowFormTemplate/getLastCreatedWorkflowFormTemplateRevisionId',

        getWorkflowFormTemplateById:
          'workflowFormTemplate/getWorkflowFormTemplateById',
        getWorkflowFormFieldById:
          'workflowFormTemplate/getWorkflowFormFieldById'
      }),

      workflowFormTemplateId(): number {
        return Number(this.$route.params.templateId);
      },

      workflowFormTemplateRevisionId(): number {
        return Number(this.$route.params.revisionId);
      },

      workflowFormTemplateRevision(): IWorkflowFormTemplateRevision {
        return this.getWorkflowFormTemplateRevisionById(
          this.workflowFormTemplateRevisionId
        );
      },

      workflowFormTemplateRevisionStatus(): IWorkflowFormTemplateRevisionStatus {
        return this.workflowFormTemplateRevision
          .state as IWorkflowFormTemplateRevisionStatus;
      }
    },

    watch: {
      tab: {
        handler(value) {
          this.scrollToSection(value);
          //set selected section
          this.selectedSectionIndex = value;
        }
      },

      navDrawer: {
        handler(val) {
          const isEqual = deepEqual(
            this.revision,
            this.getWorkflowFormTemplateRevisionById(
              this.workflowFormTemplateRevisionId
            )
          );

          if (isEqual) return;

          if (!val) {
            this.save();
          }
        }
      },

      workflowFormTemplateRevisionId: {
        handler() {
          this.loadWorkflowFormTemplate();
        }
      }
    },

    async mounted() {
      await this.loadWorkflowFormTemplate();
    },

    methods: {
      requiredValidator,

      ...mapActions({
        fetchWorkflowFormTemplateRevision:
          'workflowFormTemplate/fetchWorkflowFormTemplateRevision',
        fetchWorkflowFormTemplate:
          'workflowFormTemplate/fetchWorkflowFormTemplate',
        updateWorkflowFormTemplateRevision:
          'workflowFormTemplate/updateWorkflowFormTemplateRevision',
        updateWorkflowFormField: 'workflowFormTemplate/updateWorkflowFormField',
        fetchWorkflowFormField: 'workflowFormTemplate/fetchWorkflowFormField',
        removeWorkflowFormTemplateAttachment:
          'workflowFormTemplate/removeWorkflowFormTemplateAttachment',

        createNewWorkflowTemplateRevision:
          'workflowFormTemplate/createNewWorkflowTemplateRevision',

        updateWorkflowFormTemplateWithPublishedRevisions:
          'workflowFormTemplate/updateWorkflowFormTemplateWithPublishedRevisions'
      }),

      refreshWorkflowFormTemplate() {
        this.revisionLoading = true;

        return this.fetchWorkflowFormTemplateRevision({
          templateId: this.workflowFormTemplateId,
          revisionId: this.workflowFormTemplateRevisionId
        })
          .then(() => {
            this.setTemplateRevisionInstance();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.revisionLoading = false;
          });
      },

      async tryGetOrFetchWorkflowFormTemplate() {
        if (!this.getWorkflowFormTemplateById(this.workflowFormTemplateId)) {
          await this.fetchWorkflowFormTemplate(this.workflowFormTemplateId);
        }
      },

      async loadWorkflowFormTemplate() {
        this.revisionLoading = true;
        try {
          this.tryGetOrFetchWorkflowFormTemplate();

          const revision = await this.tryGetOrFetchFormTemplateRevision();
          this.revision = revision;

          //default selection to first section
          this.selectedSectionIndex = 0;
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            if (error.response.data.detail) {
              this.errorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        } finally {
          this.revisionLoading = false;
        }
      },

      openRemoveSectionDialog(sectionIndex: number) {
        this.selectedSectionIndex = sectionIndex;
        this.deleteDialog = true;
      },

      closeDeleteDialog() {
        this.deleteDialog = false;
        this.selectedSectionIndex = -1;
      },

      openFieldTypeDrawer(index: number, parentFieldId: number | null = null) {
        this.fieldDrawer = true;
        this.selectedFieldIndex = index;

        this.parentFieldId = parentFieldId;
      },

      //open the the field drawer on the newly created field automatically
      //occurs only if there was no error
      saveSelectedField() {
        this.save().then(() => {
          if (!this.showErrorSnackbar) {
            const selectedFieldIndex =
              (this.revision!.sections as IWorkflowFormSectionData[])[
                this.selectedSectionIndex!
              ].section_fields.length - 1;

            this.openDrawer(this.selectedSectionIndex, selectedFieldIndex);
          }
        });
      },

      openDrawer(sectionIndex: number, fieldIndex: number) {
        this.selectedFieldIndex = fieldIndex;
        this.selectedSectionIndex = sectionIndex;
        this.navDrawer = true;
      },

      scrollToSection(tab: number) {
        const element = document.getElementById(`section-${tab}`);
        const rect = element?.getBoundingClientRect();

        const containerElement = document.getElementById(`sections-container`);
        const containerRect = containerElement!.getBoundingClientRect();

        if (rect && containerElement && containerRect) {
          // Scroll to the position of the target element
          containerElement.scrollTo({
            top: element?.offsetTop,
            left: rect.left,
            behavior: 'smooth'
          });
        }
      },

      async tryGetOrFetchFormTemplateRevision(): Promise<
        IWorkflowFormTemplateRevision
      > {
        if (!this.workflowFormTemplateRevision) {
          await this.fetchWorkflowFormTemplateRevision({
            templateId: this.workflowFormTemplateId,
            revisionId: this.workflowFormTemplateRevisionId
          });
        }
        return this.workflowFormTemplateRevision!;
      },

      async tryGetOrFetchFormFieldById(id: number) {
        if (!this.getWorkflowFormFieldById(id)) {
          await this.fetchWorkflowFormField(id);
        }
        return this.getWorkflowFormFieldById(id)!;
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
        this.createNewRevisionError = null;
      },

      removeSection() {
        this.revision!.sections!.splice(this.selectedSectionIndex, 1);
        this.save().then(() => {
          this.closeDeleteDialog();
        });
      },

      addSection(index?: number) {
        const newLength = this.revision!.sections!.length + 1;
        const section = new WorkflowFormSection({
          title: `Section ${newLength}`,
          order: index ? index : newLength,
          section_fields: []
        });

        if (index) {
          this.revision!.sections!.splice(index + 1, 0, section);
          this.reorderTemplateSections();
        } else {
          this.revision!.sections!.push(section);
          this.save();
        }
      },

      reorderTemplateSections() {
        const reOrderedSections = this.revision!.sections!.map((section, i) => {
          return {
            ...section,
            order: i
          };
        });

        this.revision!.sections! = reOrderedSections;

        this.save();
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      openWorkflowFormTemplateDialog(revision?: IWorkflowFormTemplateRevision) {
        this.$refs.workflowFormTemplateRevisionDialog.open(revision);
      },

      openCreateAttachmentDialog() {
        this.$refs.addAttachmentsFormDialog.open();
      },

      openDeleteAttachmentDialog(attachment: IAttachment) {
        this.clearAllErrors();
        this.selectedAttachment = attachment;
        // Once the selected attachment is set then the attachment dialog is opened on the next frame to avoid a visual flicker of the data
        this.$nextTick(() => {
          this.attachmentDeleteDialog = true;
        });
      },

      cancelDeleteAttachmentDialog() {
        this.selectedAttachment = null;
        this.attachmentDeleteDialog = false;
      },

      removeAttachment(attachment: IAttachment) {
        this.clearAllErrors();
        this.isAttachmentDeleteInProgress = true;

        this.removeWorkflowFormTemplateAttachment({
          templateId: this.revision!.template!.id,
          attachmentId: attachment.id
        })
          .then(() => {
            this.attachmentDeleteDialog = false;
          })
          .catch(error => {
            this.attachmentDeleteError = setErrorFromAxiosError(error);
          })
          .finally(() => {
            this.isAttachmentDeleteInProgress = false;
          });
      },

      openWorkflowMetaLabelColumnsFormDialog(
        revision: IWorkflowFormTemplateRevision
      ) {
        this.$refs.workflowFormBuilderMetaLabelColumnsDialog.open(revision);
      },

      openWorkflowGrantAccessFormDialog() {
        this.grantAccessDialog = true;
      },

      setTemplateRevisionInstance() {
        this.revision = cloneDeep(this.workflowFormTemplateRevision);
      },

      updatePublishedTemplateRevisions() {
        this.setTemplateRevisionInstance();

        // fetch published revisions to update the state of other published revisions
        // no loading indicator as this is a background task
        this.updateWorkflowFormTemplateWithPublishedRevisions(
          this.getWorkflowFormTemplateById(this.workflowFormTemplateId)
        ).catch(error => {
          const err = setErrorFromAxiosError(error);
          this.errorMessage = err.message;
          this.detailErrorMessage = err.detail;
        });
      },

      async save() {
        this.loading = true;

        try {
          const formTemplateDelta = diffDeep(
            this.revision,
            this.getWorkflowFormTemplateRevisionById(
              this.workflowFormTemplateRevisionId
            ),
            true
          );

          //update changes to a formField Template
          for (let i = 0; i < formTemplateDelta!.sections!.length; i++) {
            if (formTemplateDelta!.sections![i].section_fields) {
              for (const field of formTemplateDelta!.sections![i]
                .section_fields) {
                if (
                  field.field_template &&
                  typeof field.field_template == 'object'
                ) {
                  const originalFormField = await this.tryGetOrFetchFormFieldById(
                    field.field_template.id!
                  );

                  const isEqual = deepEqual(
                    field.field_template,
                    originalFormField
                  );
                  //make sure api is only called when there is a change
                  if (!isEqual) {
                    await this.updateWorkflowFormField(field.field_template);
                  }
                  field.field_template = (field.field_template as IWorkflowFormFieldData).id!;
                }
              }
            }
          }

          await this.updateWorkflowFormTemplateRevision({
            templateId: this.workflowFormTemplateId,
            revision: formTemplateDelta
          });
        } catch (err) {
          const error = err as AxiosError;

          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
          this.showErrorSnackbar = true;
          this.revision = this.getWorkflowFormTemplateRevisionById(
            this.workflowFormTemplateRevisionId
          );
        } finally {
          this.setTemplateRevisionInstance();
          this.loading = false;
        }
      },

      closeCreateNewRevisionDialog() {
        this.createNewRevisionDialog = false;
        this.createNewRevisionError = null;
      },

      createNewRevision() {
        this.clearAllErrors();
        this.createNewRevisionInProgress = true;

        this.createNewWorkflowTemplateRevision({
          templateId: this.workflowFormTemplateRevision.template!.id,
          revisionId: this.workflowFormTemplateRevision.id
        })
          .then(() => {
            const revision = this.getWorkflowFormTemplateRevisionById(
              this.getLastCreatedWorkflowFormTemplateRevisionId
            );

            this.closeCreateNewRevisionDialog();
            this.$router
              .replace({
                name: 'workflow-form-template-detail',
                params: {
                  templateId: String(revision.template!.id),
                  revisionId: String(revision.id)
                }
              })
              .then(() => {
                this.createSnack({
                  color: 'success',
                  type: 'success',
                  right: true,
                  useBtn: false,
                  msg: 'Currently viewing latest revision',
                  btnText: 'Close',
                  timeout: 6000
                });
              })
              .then(() => {
                this.setTemplateRevisionInstance();
                this.openWorkflowFormTemplateDialog(revision);
              });
          })
          .catch(error => {
            this.createNewRevisionError = setErrorFromAxiosError(
              error as AxiosError
            );
          })
          .finally(() => {
            this.createNewRevisionInProgress = false;
          });
      }
    }
  });
